export function clearLocalStoragePreserving(groups: StorageGroup[]) {
  const prefixesToKeep = groups.flatMap((g) => USE_CASES_TO_PRESERVE[g]);

  Object.keys(localStorage).forEach((key) => {
    const shouldKeep = prefixesToKeep.some((prefix) => key.startsWith(prefix));
    if (!shouldKeep) localStorage.removeItem(key);
  });
}

export const STORAGE_GROUPS = {
  /** Help dialog "don't show again" and similar user preferences */
  helpDialogs: "helpDialogs",
} as const;

const USE_CASES_TO_PRESERVE: Record<StorageGroup, string[]> = {
  helpDialogs: ["spotsync-"],
};

type StorageGroup = keyof typeof STORAGE_GROUPS;
